// extracted by mini-css-extract-plugin
export default {"header":"style_header__zjNZY","title":"style_title__AWrVC","subtitle":"style_subtitle__+Iy5+","text":"style_text__eI-zp","back_button":"style_back_button__8bYdw"};